import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CompanyClient } from '../clients/oreg-api/company.client';
import { ListCompany } from '../models/list-company.model';
import { SearchResult } from '../models/search-result.model';

@Injectable({ providedIn: 'root' })
export class CompaniesQuery {
  constructor(private companyClient: CompanyClient) {}

  search(
    number: string,
    country: string,
    noFilter: boolean,
  ): Observable<SearchResult<ListCompany>> {
    return this.companyClient.searchCompany(number, country, noFilter);
  }
}
